import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalRuleConditionLine  {
    _originalTypeClassName = "zERP.BO.GeneralJournalRuleConditionLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalRuleConditionLine.translate = translateService;
}
this.Id = null;
this.OperatorPath = null;
this.ClassName = null;
this.Operator = null;
this.Operand2BoolValue = false;
this.Operan2StringValue = null;
this.JoinOperator = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
OperatorPath:any;
ClassName:any;
Operator:any;
Operand2BoolValue:any;
Operan2StringValue:any;
JoinOperator:any;
Operand1:any;
static setOperand1 = ($this, value) => {
var oldValue = $this.Operand1;
$this.Operand1 = value;
if (value != null) {
}
}

static Evaluate(conditions: any): any{return true;
}
static IsTrue($this: any): any{return true;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}